import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import './PageStyles.css';

const PrivacyPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="legal-page">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="legal-title">{t('privacy.title')}</h1>
          <p className="legal-date">{t('privacy.lastUpdated')}: 12.12.2025</p>
          
          <div className="legal-content">
            <section>
              <h2>{t('privacy.section1.title')}</h2>
              <p>{t('privacy.section1.content')}</p>
            </section>

            <section>
              <h2>{t('privacy.section2.title')}</h2>
              <p>{t('privacy.section2.content')}</p>
            </section>

            <section>
              <h2>{t('privacy.section3.title')}</h2>
              <p>{t('privacy.section3.content')}</p>
            </section>

            <section>
              <h2>{t('privacy.section4.title')}</h2>
              <p>{t('privacy.section4.content')}</p>
            </section>

            <section>
              <h2>{t('privacy.section5.title')}</h2>
              <p>{t('privacy.section5.content')}</p>
            </section>

            <section>
              <h2>{t('privacy.contact.title')}</h2>
              <p>{t('privacy.contact.content')}</p>
              <p>E-posta: info@ustaconsulting.com</p>
              <p>Telefon: +90 (533) 775 71 81</p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PrivacyPage;
